// Dependencies
require("webstrap/scaffolding");

// Styles
require("./forms.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/forms/index.js
 ** module id = 62
 ** module chunks = 0 1
 **/